import { memo } from "react";

import { modules } from "byzantine";
import { Button, Row } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";

import styles from "../SearchBar.module.scss";
import { useSearchBar } from "../context";

const { useIsGlobalSearchEnabled } = modules.search;

const getButtonKind = <T,>(entity: T, currentFilter: T) =>
  entity === currentFilter ? "primary" : "secondary";

const SearchBarChips = () => {
  const { l10n } = useLocalization();
  const { resultsFilter, setResultsFilter } = useSearchBar();
  const { enabledSearchEntities } = useIsGlobalSearchEnabled();

  return (
    <Row className={styles["search-chips-container"]} gapSize="xs">
      <Button
        size="s"
        kind={getButtonKind("all", resultsFilter)}
        label={l10n.getString("search-bar-results-section-title-all")}
        onClick={() => setResultsFilter("all")}
      />
      {enabledSearchEntities.transactions && (
        <Button
          size="s"
          kind={getButtonKind("transactions", resultsFilter)}
          label={l10n.getString(
            "search-bar-results-section-title-transactions"
          )}
          onClick={() => setResultsFilter("transactions")}
        />
      )}
      {enabledSearchEntities.accounts && (
        <Button
          size="s"
          kind={getButtonKind("accounts", resultsFilter)}
          label={l10n.getString("search-bar-results-section-title-accounts")}
          onClick={() => setResultsFilter("accounts")}
        />
      )}
      {enabledSearchEntities.pages && (
        <Button
          size="s"
          kind={getButtonKind("pages", resultsFilter)}
          label={l10n.getString("search-bar-results-section-title-pages")}
          onClick={() => setResultsFilter("pages")}
        />
      )}
    </Row>
  );
};

export default memo(SearchBarChips);
